import { OnlineOnboardingDetails } from '@nemuru-eng/js-api-client';

import { DetailsDataSkeleton } from '@/components/modules/AssetDetails/components/shared/DetailsDataSkeleton';
import { DigitalFootprintForm } from '@/components/modules/KYC/KYCOrder/components/DigitalFootprint/components/DigitalFootprintForm';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { SubSectionWrapper } from '@/components/shared/components/SubSectionWrapper';
import { PendingDataType } from '@/config/types';

type DigitalFootprintProps = {
  onboardingDetails?: OnlineOnboardingDetails;
  loading: boolean;
};

export const DigitalFootprint = ({ onboardingDetails, loading }: DigitalFootprintProps) => {
  if (loading) return <DetailsDataSkeleton numberOfRows={4} />;

  return (
    <SubSectionWrapper title={'DIGITAL_FOOTPRINT'}>
      {onboardingDetails ? (
        <DigitalFootprintForm borrowerDetails={onboardingDetails} />
      ) : (
        <PendingDataWarning type={PendingDataType.BORROWER_ONBOARDING} />
      )}
    </SubSectionWrapper>
  );
};
